module.exports = "https://www.gc-pro.gnp.com.mx/c58006f2ffccc4a13fa8b8e9fdd34d82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-financiero-vida.svg
// module id = 8083
// module chunks = 0